const split = 900
const baseFontSize = 37.5
const maxFontSize = 128

export function htmlFontSize() {
    let px = document.documentElement.clientWidth / 10
    if (document.documentElement.clientWidth > split) {
        px = px / (maxFontSize / baseFontSize)
    }
    return px
}

export function isYKYByWidth() {
    return document.documentElement.clientWidth > split
}

export function pxToRem(px) {
    // 处理字符串类型，提取数值
    let pxValue = px
    if (typeof px === 'string') {
        // 如果是以px结尾的字符串（忽略大小写），去掉px后缀
        if (px.toLowerCase().endsWith('px')) {
            pxValue = parseFloat(px.replace(/px$/i, ''))
        } else {
            // 如果是纯数字字符串，直接转换为数字
            pxValue = parseFloat(px)
        }
    }
    
    // 如果转换后不是有效数字，返回原值
    if (isNaN(pxValue)) {
        return px
    }
    
    // 计算rem值
    if (document.documentElement.clientWidth > split) {
        return pxValue / baseFontSize + 'rem'
    }
    return pxValue / baseFontSize + 'rem'
}